import { render, staticRenderFns } from "./FootMain.vue?vue&type=template&id=40ae93ab&scoped=true&"
import script from "./FootMain.vue?vue&type=script&lang=js&"
export * from "./FootMain.vue?vue&type=script&lang=js&"
import style0 from "./FootMain.vue?vue&type=style&index=0&id=40ae93ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ae93ab",
  null
  
)

export default component.exports